/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { TodoListViewerFragmentDoc } from '../../components/organisms/TodoList/TodoList.generated';
export type DashboardPageTodoListSectionViewerFragment = { todoList: { showSeminar: boolean, showAutoKartePlannerCommentSetting: boolean, showWriteProfile: boolean } };

export const DashboardPageTodoListSectionViewerFragmentDoc = gql`
    fragment DashboardPageTodoListSectionViewer on Viewer {
  ...TodoListViewer
}
    ${TodoListViewerFragmentDoc}`;